<template>
  <div class="snackbar" v-if="showSnackbar" :class="currentState.bgColor">
    <div class="inner">
      <a class="close" href="#0" @click.prevent="$emit('close')"></a>
      <div class="content">
        <p v-html="currentState.message"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['states', 'state', 'bgColor', 'showSnackbar'],

  data() {
    return {
      currentState: {name: undefined}
    }
  },

  watch: {
    state: function(newVal, oldVal) {
      this.currentState = this.states.find(state => state.name == newVal);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './../css/variables.css';

  .inner {
    margin: auto;
    position: relative;
  }

  .snackbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    display: flex;
    background: rgba(255, 255, 255, 0.7);

    &.aqua {
      .inner {
        background: var(--aqua);
      }
    }

    &.light_purple {
      .inner {
        background: var(--light_purple);
      }
    }

    &.white {
      .inner {
        background: white;
      }
    }
  }

  .content {
    padding: 60px 20px;
    margin: 0;

    p {
      margin: 0 !important;
      padding: 0;
    }
  }

  p {
    a {
      border-bottom: 2px solid;
      transition: 0.3s all;

      &:hover {
        border-bottom-color: transparent;
      }
    }
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    display: block;
    width: 40px;
    height: 40px;

    &::after,
    &::before {
      display: block;
      width: 40px;
      height: 2px;
      content: '';
      position: absolute;
      background: black;
      top: 20px;
      left: 0;
    }

    &::after {
      transform: rotate(45deg);
    }

    &::before {
      transform: rotate(-45deg);
    }
  }

  @media (min-width: 768px) {
    .content {
      padding: 60px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/components/Snackbar.vue